"use client";

import React, { useEffect, useState } from "react";
import api from "../../services/api";
import {
  FaUsers,
  FaUserCheck,
  FaLink,
  FaCreditCard,
  FaChartBar,
  FaDollarSign,
  FaTimesCircle,
  FaQrcode,
  FaSyncAlt,
} from "react-icons/fa";
import AdminLayout from "../../components/admin/Layout/AdminLayout";
import { StatCard } from "../../components/admin/StatCard";
import AdminUsersSection from "../../components/admin/AdminUsersSection";


export default function AdminDashboardPage() {
  const [overview, setOverview] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOverview = async () => {
      try {
        const res = await api.get("/admin/overview");
        setOverview(res.data);
      } catch (err) {
        console.error("Failed to load admin overview", err);
      } finally {
        setLoading(false);
      }
    };

    fetchOverview();
  }, []);


  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <FaSyncAlt className="me-2 fa-spin" />
        Loading dashboard…
      </div>
    );
  }

  if (!overview) return null;

  const { users, links, subscriptions, analytics, revenue } = overview;

  const cards = [
    {
      title: "Total Users",
      value: users.total,
      icon: <FaUsers />,
      badge: { label: "Users", variant: "primary" },
      trend: { value: 12.5, isPositive: true },
    },
    {
      title: "Verified Users",
      value: users.verified,
      icon: <FaUserCheck />,
      badge: { label: "Verified", variant: "success" },
      progress: users.total
      ? (users.verified / users.total) * 100
      : 0,
    },
    {
      title: "Total Links",
      value: links.total,
      icon: <FaLink />,
      badge: { label: "Links", variant: "secondary" },
    },
    {
      title: "Active Subscriptions",
      value: subscriptions.active,
      icon: <FaCreditCard />,
      badge: { label: "Active", variant: "success" },
    },
    {
      title: "Expired Subscriptions",
      value: subscriptions.expired,
      icon: <FaTimesCircle />,
      badge: { label: "Expired", variant: "danger" },
    },
    {
      title: "Total Traffics",
      value: analytics.totalClicks,
      icon: <FaChartBar />,
      badge: { label: "Clicks", variant: "info" },
    },
    {
      title: "QR Scans",
      value: analytics.totalQrScans,
      icon: <FaQrcode />,
      badge: { label: "QR", variant: "warning" },
    },
    {
      title: "Revenue",
      value: `$${(revenue.total || 0).toLocaleString()}`,
      icon: <FaDollarSign />,
      badge: { label: "Revenue", variant: "success" },
    },
    {
  title: "Monthly Subscriptions",
  value: subscriptions.monthlyActive,
  icon: <FaCreditCard />,
  badge: { label: "Monthly", variant: "info" },
},
{
  title: "Yearly Subscriptions",
  value: subscriptions.yearlyActive,
  icon: <FaCreditCard />,
  badge: { label: "Yearly", variant: "dark" },
},
{
  title: "Monthly Revenue",
  value: `$${(revenue.monthly || 0).toLocaleString()}`,
  icon: <FaDollarSign />,
  badge: { label: "Monthly", variant: "info" },
},
{
  title: "Yearly Revenue",
  value: `$${(revenue.yearly || 0).toLocaleString()}`,
  icon: <FaDollarSign />,
  badge: { label: "Yearly", variant: "dark" },
},

  ];

  return (
    <AdminLayout>
    <div className="container-fluid py-4 bg-light min-vh-100">
      <div className="container">
        <h1 className="fw-bold mb-4">Admin Dashboard</h1>

        <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-4 g-4">
          {cards.map((card, index) => (
            <StatCard key={index} {...card} />
          ))}
        </div>
        {/* Users management section */}
        <AdminUsersSection />
      </div>
    </div>
    </AdminLayout>
  );
}
